import { render, staticRenderFns } from "./VerticalNavMenuClose.vue?vue&type=template&id=7001b759&scoped=true"
import script from "./VerticalNavMenuClose.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuClose.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuClose.vue?vue&type=style&index=0&id=7001b759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7001b759",
  null
  
)

export default component.exports